<template>
	<div>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>变动信息</span>
			</div>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="变动编号">{{ data.changeNo }}</el-descriptions-item>
				<el-descriptions-item label="变动类型">
					<el-tag :type="AssetChangeType[data.changeType] || 'default'" class="tag" size="mini">
						{{ $menu.getLabel('AssetChangeType', data.changeType) }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="资产编号">{{ data.assetNo }}</el-descriptions-item>
				<el-descriptions-item label="资产名称">{{ data.assetName }}</el-descriptions-item>
				<el-descriptions-item label="所属项目">{{ data.communityName }}</el-descriptions-item>
				<el-descriptions-item label="变动日期">{{ data.createTime }}</el-descriptions-item>
				<el-descriptions-item label="操作人">{{ data.updater }}</el-descriptions-item>
				<el-descriptions-item label="变动状态">
					<!-- <el-tag type="success" size="small">已完成</el-tag> -->
					--
				</el-descriptions-item>
			</el-descriptions>
			<el-divider></el-divider>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="变更前">{{ data.changeBefore }}</el-descriptions-item>
				<el-descriptions-item label="变更后">{{ data.changeAfter }}</el-descriptions-item>
			</el-descriptions>
			<el-divider></el-divider>
			<div class="remark">
				<div>变动说明：</div>
				<div class="remark-info">{{ data.changeDescription }}</div>
			</div>
		</el-card>
		<el-card class="table-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>附件</span>
			</div>
			<div>
				<el-empty :image-size="100" description="暂无附件"></el-empty>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { AssetChangeType } from '@/utils/meunType.js';
	export default {
		name: 'AssetDynamicBaseInfo',
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return { AssetChangeType };
		},
		methods: {},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}

	.remark {
		margin-top: 20px;
		color: #1c1c1c;
		font-size: 14px;
		font-weight: 500;
		&-info {
			margin-top: 8px;
			box-sizing: border-box;
			background-color: #ebebeb;
			width: 100%;
			padding: 10px 12px;
			color: #333;
			border-radius: 5px;
		}
	}

	.depreciation-list {
		display: flex;
		justify-content: space-between;
		align-items: center;
		.depreciation-item {
			display: flex;
			flex-direction: column;
			gap: 6px;
			font-size: 20px;
			color: #1c1c1c;
		}
		.depreciation-item :first-child {
			font-size: 14px;
			color: #666;
		}
	}
</style>
